<template>
  <div>
    <stepper :options="options" v-model="step">
      <div slot="step-0">
        <u-custom-select
          v-model="model.domain"
          :items="domains"
        ></u-custom-select>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
        <p class="waring">* Compulsory Fields</p>
      </div>
      <div slot="step-1">
        <u-custom-select
          v-model="model.subdomain"
          :items="subdomains"
        ></u-custom-select>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
      <div slot="step-2">
        <u-custom-select
          v-model="model.topic"
          :items="topics"
        ></u-custom-select>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
      <div slot="step-3">
        <div class="cr_terms" v-if="$route.params.type === 'consultant'">
          <ol>
            <li>
              UPSKILL will make any consultancy offer in email communication or
              sms notification and phone calls via its platform
            </li>
            <li>
              The Offer will in any case at least state the following
              information:
            </li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>Topic of consultation</li>
              <li>Name and designation of the consultee</li>
              <li>Scheduled date and time</li>
            </ul>

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              All consultants will accept the payment from users in the
              following fee structure: TK. 1000 for the first 3 consultations,
              TK. 2000 for the next 3 consultations, and TK. 3000 from the 7th
              consultation onwards. However, Upskill will keep 30% of the
              payment as a fee to cover it costs for holding consultation
              sessions.
            </ul>
          </ol>
        </div>
        <div class="cr_terms" v-if="$route.params.type === 'trainer'">
          <ol>
            <li>
              UPSKILL will make any workshop/training online or offline offer in
              email communication or sms notification and phone calls via its
              platform
            </li>
            <li>The Offer will contain the following information:</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>Topic</li>
              <li>Learning outcome</li>
              <li>Scheduled date and time</li>
            </ul>

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>
                All trainers will accept 30% of total workshop profit
                irrespective of the workshop pricing, be it online or offline.
              </li>
              <li>
                First time trainers must do a 1 hour 30 minutes online session
                or 3 hours offline session for free.
              </li>
              <li>
                If you have any reservations regarding payment, please feel free
                to contact Upskill directly at 01727234132.
              </li>
              <li>
                By accepting all the conditions you will abide `by these
                contract terms.
              </li>
            </ul>
          </ol>
        </div>
        <div class="cr_terms" v-if="$route.params.type === 'nrb'">
          <ol>
            <li>
              UPSKILL will make any workshop/training online or offline offer in
              email communication or sms notification and phone calls via its
              platform
            </li>
            <li>
              The Offer contains a description of the Training and / or material
              that is part of the Training.
            </li>
            <li>The Offer will contain the following information:</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>Proposed session topic</li>
              <li>Scheduled date and time</li>
            </ul>

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>NRB Connect sessions are paid sessions</li>
              <li>
                Upskill is unable to pay the trainer because of strict currency
                control for overseas payment
              </li>
              <li>
                Instead trainers can opt to provide a one time donation to JAAGO
                Foundation. JAAGO Foundation works with a vision - to eliminate
                poverty through education. Today, JAAGO Foundation supports the
                education of 3500 children across its 12 branches all over
                Bangladesh.
              </li>
              <li>
                One time Donation amount will range from Tk. 1000 to a total of
                20% NRB Connect Session profit.
              </li>
              <li>
                Upskill reserves the right to choose what amount is appropriate
                for the respective NRB sessions after accounting for all
                marketing costs and donate the amount on behalf of speakers to
                Jagoo school, every time they take a paid online session. A
                digital receipt of the donation will be sent to for their
                record.
              </li>
              <li>
                By accepting all the conditions you will abide `by these
                contract terms.
              </li>
            </ul>
          </ol>
        </div>
        <ubtn @click.prevent.native="accept" :loading="loading">Accept</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
    </stepper>
  </div>
</template>

<script>
import Stepper from "../components/Stepper";
export default {
  name: "consultant",
  components: {
    Stepper
  },
  data() {
    return {
      dob: "",
      loading: false,
      step: 0,
      selected: "",
      confirmPassword: "",
      model: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        dob: "",
        occupation: "",
        company: "",
        bio: "",
        imageURL: "",
        location: "",
        type: "",
        other: {
          expertise: [],
          attendant: [],
          interests: [],
          referrer: []
        },
        linkedin: ""
      },
      options: {
        headers: [
          {
            title: "Submit an Assessment",
            subtitle: "Please select a domain for your assessment",
            img: require("../assets/images/registration-02.png")
          },
          {
            title: "Submit an Assessment",
            subtitle:
              "Please select a subdomain that is related to your assessment",
            img: require("../assets/images/registration-02.png")
          },
          {
            title: "Submit an Assessment",
            subtitle:
              "Please select a topic under which your assessment will be created",
            img: require("../assets/images/registration-02.png")
          },
          {
            title: "Terms & Condition",
            subtitle:
              "By clicking accept you agree to the terms and conditions",
            img: require("../assets/images/registration-06.png")
          }
        ]
      },
      interests: [
        "Digital Marketing",
        "Business",
        "Coding / Programming",
        "Art And Design",
        "Data Analytics",
        "Others"
      ],
      reasons: [
        "Develop my skills",
        "Get my first job",
        "Increase my earning",
        "Change my career",
        "To learn from experts",
        "Other"
      ],
      referral: [
        "Facebook",
        "LinkedIn",
        "Google Search",
        "Friend/Family",
        "Event/News",
        "Article/Blog",
        "Other"
      ],
      domains: [],
      subdomains: [],
      topics: []
    };
  },
  methods: {
    next() {
      switch (this.step) {
        case 0:
          this.getSubDomains();
          break;
        case 1:
          this.getSubDomains();
          break;
        case 2:
          this.getTopics();
          break;
      }
    },
    prev() {
      this.step--;
    },
    getDomains() {
      this.$upskill.appDomains().then(res => {
        this.domains = res.data;
      });
    },
    getSubDomains() {
      this.$upskill.appSubdomains(this.model.domain.id).then(res => {
        this.subdomains = res.data;
        this.step++;
      });
    },
    getTopics() {
      this.$upskill.appTopics(this.model.subdomain.id).then(res => {
        this.topics = res.data;
        this.step++;
      });
    }
  },
  created() {
    this.Loaded();
    this.getDomains();
  }
};
</script>

<style scoped></style>
